/** Narrowing for values of unknown shape: caught errors, SDK payloads, parsed response bodies. */

export const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  typeof value === 'object' && value !== null ? value as Record<string, unknown> : undefined

export const asString = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined
